import {SessionActivityName} from 'interfaces';

export const DEFAULT_ICON_BACKGROUND = '#0047FF';

export const ACTIVITIES: SessionActivityName[] = [
    SessionActivityName.TextChat,
    SessionActivityName.Audio,
    SessionActivityName.AudioVideo,
    SessionActivityName.SIP,
    SessionActivityName.Avatar
];